import { createFileRoute } from '@tanstack/react-router';
import type { IconName } from 'lucide-react/dynamic';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Content } from '@/components/ui/content';
import { CopyText } from '@/components/ui/copy-text';
import { Form, FormContent } from '@/components/ui/form';
import { ContentLoader } from '@/components/ui/loaders';
import { meta } from '@/lib/meta';
import { ScreenForm } from '@/lib/screen-renderer';
import { useDynamicDetail } from '@/services/dynamic-resource';
import { useScreenByResource } from '@/services/screens';

export const Route = createFileRoute('/_app/$resource/$id/view')({
  head: () => meta({ label: 'Visualizar' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { resource, id } = Route.useParams();

  const { data: screen, isLoading: loadingScreen } = useScreenByResource(resource);
  const { data, isLoading: loadingData } = useDynamicDetail(resource, id);

  const form = useForm<Record<string, any>>({
    disabled: true,
  });

  useEffect(() => {
    if (data) form.reset(data);
  }, [data, form]);

  if (loadingScreen || !screen || loadingData || !data) return <ContentLoader show />;

  const label = screen.label;
  const shortId = id?.slice(0, 8);

  return (
    <Content
      breadcrumbs={{
        title: (
          <>
            {label} <CopyText className="ml-2" value={id} label={`${shortId}...`} />
          </>
        ),
        icon: screen.icon as IconName,
        items: [
          { label: 'Listagem', route: `/${resource}` },
          { label: 'Visualizar', active: true },
        ],
      }}
    >
      <Form
        id="form"
        title={`Dados do ${label}`}
        description={`Informe os dados do ${label.toLowerCase()}.`}
      >
        <FormContent>
          <ScreenForm
            fields={screen.layout.fields}
            control={form.control}
            mode="view"
            resource={resource}
            recordId={id}
          />
        </FormContent>
      </Form>
    </Content>
  );
}
